export default {
  testItemTitle: 'Test Item',
  testItemId: 'Test Item Id',
  testItemDesc: 'Test Item Desciption',
  buttonNewResultItem: 'New Result Item',
  nickname: 'Nickname',
  sub_category_desc: 'Laboratory',
  buttonNewTestItem: 'New Test Item',
  buttonDeleteTesetItem: 'Delete Teset Item',
  newtestItem: 'New Test Item',
  idMissing: 'Please Enter Test Item ID',
  descMissing: 'Please Enter Test Item Description',
  nicknameMissing: 'Please Enter Test Item Nickname',
  categoryMissing: 'Please Enter Test Item Lab laboratory',
  confirmDeleteSelected: 'Are you sure you want to delete selected Test Item?',
  messageDeleteNotSelected: 'Please select Test Item to delete',
  editHeader: 'Edit Test Item',
  addHeader: 'Add Test Item'
}
